import { GetStaticProps, GetStaticPaths } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import Image from 'next/image';
import Container from '~/components/common/container';
import { Translate, useTranslate } from '~/i18n';
import { publicUrl } from '~/utils/publicUrl';

const CommunityGroups = () => {
   const { translate, lang } = useTranslate();
   return (
      <section className="bg-primary-blue-dark py-16 relative" style={{ minHeight: 600 }}>
         <div
            className="absolute ltr:left-0 rtl:right-0 transform rtl:scale-x-flip inset-y-0 bg-cover bg-no-repeat max-w-full bg-bottom"
            style={{
               backgroundImage: 'url("/images/home-page/groups.jpg")',
               width: 800,
            }}
         />
         <Container className="relative z-10">
            <div className="flex text-white flex-wrap">
               <div className="w-full mb-6 xl:mb-0 px-4 lg:w-1/2">
                  <span className="block text-3xl font-bold mb-10">
                     <Translate id="groups:join groups" />
                  </span>
                  <span className="block text-3xl whitespace-pre-wrap">
                     <Translate id="groups:discover groups" />
                  </span>

                  <div className="py-16 ">
                     <span className="text-2xl font-bold block mb-8">
                        <Translate id="groups:download title" />
                     </span>

                     <div className="flex  rtl:space-x-reverse flex-wrap space-x-2">
                        <a
                           target="_blank"
                           rel="noreferrer noopener"
                           aria-label={translate({ id: 'common:download appstore' })}
                           href="https://apps.apple.com/us/app/webook-com-fun-things-to-do/id6468667896">
                           <Image
                              key={`appstore${lang}`}
                              src={publicUrl(
                                 lang === 'sa-ar' ? 'images/appstore_ar.svg' : 'images/appstore.svg'
                              )}
                              alt={translate({ id: 'seo:home alt' })}
                              width={140}
                              height={41}
                           />
                        </a>
                        <a
                           target="_blank"
                           rel="noreferrer noopener"
                           aria-label={translate({ id: 'common:download playstore' })}
                           href="https://play.google.com/store/apps/details?id=com.webook.android">
                           <Image
                              key={`playstore${lang}`}
                              src={publicUrl(
                                 lang === 'sa-ar'
                                    ? 'images/playstore-ar.svg'
                                    : 'images/playstore.svg'
                              )}
                              alt={translate({ id: 'seo:home alt' })}
                              width={140}
                              height={41}
                           />
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </Container>
      </section>
   );
};

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};

export default CommunityGroups;
